import { ScenePlayer, VV } from 'arka-players';

const playerProvider = (function () {
  const instances = {
    mappedVV: null,
    orbitalExt: null,
    orbitalSitu: null,
    orbitalInt: null,
  };

  return {
    getInstance: function (playerName) {
      if (!instances[playerName]) {
        let instance;
        switch (playerName) {
          case 'mappedVV':
            instance = new VV();
            break;
          case 'orbitalExt':
            instance = new ScenePlayer({
              dragZoom: { zoom: { initialValue: 'cover' } },
            });
            break;
          case 'orbitalInt':
            instance = new ScenePlayer({
              dragZoom: { zoom: { initialValue: 'cover' } },
            });
            break;
          case 'orbitalSitu':
            instance = new ScenePlayer({ passive: true });
            break;
          default:
        }
        instances[playerName] = instance;
      }
      return instances[playerName];
    },
  };
})();

export default playerProvider;
